export default "/_next/static/images/d4fa4971ff885c7dd6fecafe17fae114.png";